import { CreateCouponRequest } from "@/data/dtos/requests";
import { z } from "zod";

export const CreateCouponRequestSchema: z.ZodType<CreateCouponRequest> =
  z.object({
    name: z.string(),
    code: z.string(),
    percent_off: z.number().int().min(1).max(100),
    redeem_by: z.string().optional(),
    max_redemptions_customers: z.number().int().positive().nullable().optional(),
  });
